// React
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Context
import { AppContext } from '../../../model/context/app/app';

// Libs
import { Icon, Menu } from 'semantic-ui-react';

// services
import LeadExcelExportService from '../../../services/LeadExcelExport.service';
import { PublicationEditorModal } from '../../../components/publicationeditor/PublicationEditorModal';

// Types
type LeadsListToolbarComponentProps = {
    onRefresh: () => void;
    onFilterLeadSpam: (doFilter: boolean) => void;
    filterLeadSpamActive?: boolean;
};

/**
 * Wrapper component as toolbar for the leads list. You can handle some features and show a smarter or short table list or results.
 *
 * @param props LeadsListToolbarComponentProps
 * @returns React.ReactElement
 */
export default function LeadsListToolbarComponent(props: LeadsListToolbarComponentProps): React.ReactElement {
    const { t } = useTranslation();

    const context = useContext(AppContext);
    const [token, setToken] = useState('');
    const excelService = new LeadExcelExportService();

    const [editorVisible, setEditorVisible] = useState(false);

    useEffect(() => {
        setToken(context.token);
    }, [context]);

    function toggleFilterLeadSpam() {
        props.onFilterLeadSpam(!props.filterLeadSpamActive);
    }

    return (
        <>
            <Menu>
                {/* REFRESH the list */}
                <Menu.Item onClick={() => props.onRefresh()} data-testid="LeadsListToolbar.Refresh">
                    <Icon name="redo" />
                    {t('lead.list.tools.refresh')}
                </Menu.Item>
                <Menu.Item onClick={toggleFilterLeadSpam} active={props.filterLeadSpamActive}>
                    <Icon name="trash" />
                    {t('lead.list.tools.filterSpam')}
                </Menu.Item>
                <Menu.Item onClick={() => excelService.fetchExport(token)}>
                    <Icon name="download" />
                    {t('lead.list.tools.excelExport')}
                </Menu.Item>
                <Menu.Item onClick={() => setEditorVisible(true)}>
                    <Icon name="file code" />
                    {t('publicationEditor.headline')}
                </Menu.Item>
            </Menu>
            <PublicationEditorModal showModal={editorVisible} onClose={() => setEditorVisible(false)} />
        </>
    );
}
